// Fundo da identidade MPires — círculos concêntricos + linha diagonal 9°, estilo login.
import React from "react";

export const COLORS = {
  navy: "#003E62",
  navy2: "#004D74",
  navy3: "#006588",
  cyan: "#008BB0",
  mobileBg: "#16385B",
  mb1: "#105176",
  mb2: "#086A91",
  accent: "#99D1DF",
  textSec: "#D7E6EE",
  textTer: "#B9CDD9",
};

// Projetor: fundo #003E62 com círculos (80vw/54vw/20vw) à direita-centro.
export function FundoProjetor() {
  return (
    <div aria-hidden style={{ position: "absolute", inset: 0, pointerEvents: "none", overflow: "hidden" }}>
      <div style={{ position: "absolute", width: "80vw", height: "80vw", borderRadius: "50%", background: COLORS.navy2, left: "calc(78% - 40vw)", top: "calc(70% - 40vw)" }} />
      <div style={{ position: "absolute", width: "54vw", height: "54vw", borderRadius: "50%", background: COLORS.navy3, left: "calc(78% - 27vw)", top: "calc(70% - 27vw)" }} />
      <div style={{ position: "absolute", width: "20vw", height: "20vw", borderRadius: "50%", background: COLORS.cyan, left: "calc(78% - 10vw)", top: "calc(70% - 10vw)" }} />
    </div>
  );
}

// Celular: fundo escuro mobile (#16385B) com 3 círculos saindo do canto superior esquerdo (620/420/180).
export function FundoMobile() {
  return (
    <div aria-hidden style={{ position: "absolute", inset: 0, pointerEvents: "none", overflow: "hidden" }}>
      <div style={{ position: "absolute", width: 620, height: 620, borderRadius: "50%", background: COLORS.mb1, left: -340, top: -340 }} />
      <div style={{ position: "absolute", width: 420, height: 420, borderRadius: "50%", background: COLORS.mb2, left: -240, top: -240 }} />
      <div style={{ position: "absolute", width: 180, height: 180, borderRadius: "50%", background: COLORS.cyan, left: -70, top: -70 }} />
    </div>
  );
}

// Faixa de topo (Treinamentos): #003E62 com círculos reduzidos.
export function FundoFaixa() {
  return (
    <div aria-hidden style={{ position: "absolute", inset: 0, pointerEvents: "none", overflow: "hidden", borderRadius: "inherit" }}>
      <div style={{ position: "absolute", width: 520, height: 520, borderRadius: "50%", background: COLORS.navy2, right: -200, top: -280 }} />
      <div style={{ position: "absolute", width: 360, height: 360, borderRadius: "50%", background: COLORS.navy3, right: -100, top: -180 }} />
      <div style={{ position: "absolute", width: 140, height: 140, borderRadius: "50%", background: COLORS.cyan, right: 40, top: -40 }} />
    </div>
  );
}
